import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography, Button } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';

const certifications = [
    {
        title: "AWS Certified Cloud Practitioner",
        issuer: "Amazon Web Services",
        date: "2024",
        image: "AWS.png",
        verifyUrl: "https://www.credly.com/badges/12c6cc95-4e6c-4b1b-bd28-5722725b499e/public_url",
        type: "pdf"
    },
    {
        title: "Certified in Cybersecurity (CC)",
        issuer: "ISC²",
        date: "2024",
        image: "cc.png",
        verifyUrl: "https://www.credly.com/badges/20fc31a1-adae-4ade-918f-1b9ad0a32dd0/public_url",
        type: "image"
    }
];

const Certifications = () => {
    return (
        <Box sx={{ maxWidth: 900, mx: 'auto', p: { xs: 2, sm: 3 } }}>
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <Typography
                        className="minimal-title"
                        variant="h3"
                        sx={{ textAlign: 'center', mb: 3, fontWeight: 700 }}
                    >
                        Certifications
                    </Typography>
                </motion.div>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
                    {certifications.map((cert) => (
                        <Box key={cert.title} sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                            <Typography sx={{ fontWeight: 600 }}>{cert.title}</Typography>
                            <Typography sx={{ color: 'text.secondary' }}>— {cert.issuer}, {cert.date}</Typography>
                            <Button href={cert.verifyUrl} target="_blank" size="small" startIcon={<OpenInNew />}>Verify</Button>
                        </Box>
                    ))}
                </Box>
            </Box>
        );
    };

    export default Certifications;